<form class="w-100 h-100 form" [formGroup]="cardForm" (ngSubmit)="sendData()">
  <h4 class="text-center">Nuevo Card</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-12 pl-xl-0 mt-2 mb-4">
      <div class="vs-outline-editCard btn-custom-banner">
        <img class="given-img ng-star-inserted menu-img mb-4" [src]="srcData" alt="img-banner" *ngIf="fileImg64">
        <div class="btn-custom-file w-100">
          <label for="file-upload-logo" class="custom-file-upload h-fit-content p-3">
            <mat-icon>{{!fileImg64 ? 'image': '' }} </mat-icon>
            <span class="my-2" *ngIf="!wrongSize">
              Elegir imagen de 200px x 150px
            </span>
            <span class="my-2 text-danger" *ngIf="wrongSize">{{wrongSize}}</span>
          </label>
          <input id="file-upload-logo" type="file" accept="image/*" (change)="getBase64($event)" />
        </div>
      </div>
    </div>
    <div class="col-9">
      <div class="my-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Título</mat-label>
          <input matInput placeholder="Título" formControlName="title" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div class="mb-3">
        <div>
          <h5 class="fw-bold m-0">Orden</h5>
        </div>
        <mat-button-toggle-group formControlName="order" aria-label="order">
          <mat-button-toggle [value]="1">1</mat-button-toggle>
          <mat-button-toggle [value]="2">2</mat-button-toggle>
          <mat-button-toggle [value]="3">3</mat-button-toggle>
          <mat-button-toggle [value]="4">4</mat-button-toggle>
          <mat-button-toggle [value]="5">5</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
    <!--    <div class="col-6">-->
    <!--      <div class="mb-3">-->
    <!--        <div>-->
    <!--          <h5 class="fw-bold m-0">Tamano de imagen</h5>-->
    <!--        </div>-->
    <!--        <mat-button-toggle-group formControlName="codeImg" aria-label="codeImg">-->
    <!--          <mat-button-toggle [value]="1">1</mat-button-toggle>-->
    <!--          <mat-button-toggle [value]="2">2</mat-button-toggle>-->
    <!--          <mat-button-toggle [value]="3">3</mat-button-toggle>-->
    <!--        </mat-button-toggle-group>-->
    <!--        <div>-->
    <!--          <small>1: small - 2: medium - 3: large</small>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="col-12">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Contenido</mat-label>
          <textarea matInput #content [maxlength]="maxLength" placeholder="Contenido" formControlName="subTitle" required></textarea>
          <mat-hint align="end">{{content.value?.length || 0}}/{{maxLength}}</mat-hint>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row mx-0 mb-3 p-0 w-100">
      <div class="col-2 mb-3">
        <h5 class="m-0 font-weight-bold">¿Tendrá Url?</h5>
        <!--        <mat-radio-group-->
        <!--          aria-labelledby="example-radio-group-label"-->
        <!--          class="example-radio-group"-->
        <!--          [(ngModel)]="urlExist">-->
        <!--          <mat-radio-button class="example-radio-button mx-2" [value]="true" (change)="resetWizzards()" >Si</mat-radio-button>-->
        <!--          <mat-radio-button class="example-radio-button mx-2" [value]="false">No</mat-radio-button>-->
        <!--        </mat-radio-group>-->
        <mat-button-toggle-group #urlExist="matButtonToggleGroup" (click)="hasURLChange(urlExist.value)" value='no'>
          <mat-button-toggle value="yes" aria-label="yes">
            <mat-icon style="color: green">check</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="no" aria-label="no" (click)="resetWizzards(true)">
            <mat-icon style="color: red">cancel</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="col-4 my-3" *ngIf="urlExist.value === 'yes'">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Link de redirección de la card</mat-label>
          <input matInput type="text" placeholder="Link de redirección" formControlName="url" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
      <div class="col-2 mb-3" *ngIf="urlExist.value === 'yes'">
        <h5 class="m-0 font-weight-bold">¿Tipo Botón?</h5>
        <mat-button-toggle-group #buttonType="matButtonToggleGroup" formControlName="activeButton"
          (click)="hasButtonTypeChange(buttonType.value)">
          <mat-button-toggle [value]="1" aria-label="yes">
            <mat-icon style="color: green">check</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle [value]="0" aria-label="no" (click)="resetWizzards(false)">
            <mat-icon style="color: red">cancel</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="col-4 my-3" *ngIf="cardForm.get('activeButton').value === 1 && urlExist.value === 'yes'">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Texto de botón</mat-label>
          <input matInput type="text" placeholder="texto de boton" formControlName="nameButton" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>


  <div class="bottom-button">
    <button class="vs-btn-blue" type="submit" [disabled]="cardForm.invalid">
      Guardar
    </button>
  </div>
</form>
